import { ErrorHandler, Inject, Injectable, InjectionToken } from '@angular/core';
import * as Rollbar from 'rollbar';
import { environment } from '../../../../../environments/environment';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

const rollbarConfig = {
  accessToken: environment.rollbarKey,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.environmentName
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(
    @Inject(RollbarService) private rollbar: Rollbar
  ) {
  }  

  handleError(err: any): void {
    if (!environment.production) {
      console.error('Error is: ', err);
    }
    if (this.rollbar) {
      this.rollbar.error(err.originalError || err);
    }
  }
}

export function rollbarFactory(appConfig: any) {  
  setTimeout(() => {    
    if (isNotNullOrUndefined(appConfig.config_json) && appConfig.config_json.useRollbar) {
      return new Rollbar(rollbarConfig);
    } else {return null};
  }, 2000);
}
